export const ENTERPRISE_USERS = [
  {
    email: "cmcintyre@marqeta.com",
    finchId: "0pJHWN-WKA8-9IX0-7qMo-7ebjrhcomN",
  },
  {
    email: "asholomytskyy@marqeta.com",
    finchId: "05otjf-GVcN-XUkX-uc2P-EyArqmMua7",
  },
  {
    email: "tsingh@marqeta.com",
    finchId: "1CQQbj-2gqC-IGgf-xhad-GGKmzyk5wf",
  },
  {
    email: "oespaillat@marqeta.com",
    finchId: "4Hrfzf-TRyp-bqGs-028Z-mutAG10NSV",
  },
  {
    email: "rgraziosi@marqeta.com",
    finchId: "4qZwse-tJID-YjiX-lX74-YU4OsJlcZT",
  },
  {
    email: "mfrankhuff@marqeta.com",
    finchId: "5TU45F-1C9X-Ku7Y-26Hk-3riRseE7Ub",
  },
  {
    email: "tpress@marqeta.com",
    finchId: "62LcpW-IQ8B-SOo4-Ws8G-QEoLb8SOqs",
  },
  {
    email: "rshah@marqueta.com",
    finchId: "68uuFN-djg4-PY2M-TffJ-uIjUwqwNG4",
  },
  {
    email: "cironside@marqeta.com",
    finchId: "8qC5fQ-QaEZ-h8sC-xOBo-92BcWkBFCJ",
  },
  {
    email: "spitts@marqeta.com",
    finchId: "9nFi0p-8zCO-TmIl-ea3z-WwSaoq46Ld",
  },
  {
    email: "shauber@marqeta.com",
    finchId: "9gCKW8-B8Gj-qdAR-0vFQ-BjUakjAlQS",
  },
  {
    email: "kchatterjee@marqeta.com",
    finchId: "9wFiCg-6zxI-76h3-gsza-ylrqliVF2W",
  },
  {
    email: "rleyva@marqeta.com",
    finchId: "1xqcM6-iWns-3LhO-X8CQ-D9X7g6GxYc",
  },
  {
    email: "jfoggiato@marweta.com",
    finchId: "3sYrwC-Jlv4-XSF9-miBW-R3rREEfVgE",
  },
  {
    email: "rahulshahtester@gmail.com",
    finchId: "3vHHDf-KQXo-WWYl-vCy5-GxEYSldIeY",
  },
  {
    email: "kjoshi@marqeta.com",
    finchId: "8T05Qz-LXSH-swXr-pouP-ReFG73yChb",
  },
  {
    email: "sraut@marqeta.com",
    finchId: "3TfozQ-B3OP-qsDE-lAEe-dfUwYdo7er",
  },
  //* <------- Madan added these ids --------
  {
    email: "tbhalerao@marqeta.com",
    finchId: "3f4de56b-a38d-445b-9d5e-005c10bba895",
  },
  {
    email: "treed@marqeta.com",
    finchId: "2e5ff51f-51a0-4c10-8f61-a10a229d89c1",
  },
  {
    email: "sgu@marqeta.com",
    finchId: "29a329b0-d1e6-4d71-badb-a1e4bc61c443",
  },
  {
    email: "smedepalli@marqeta.com",
    finchId: "96a7d2c6-138e-42b5-9fe7-6c2ed0f991bb",
  },
  {
    email: "chsu@marqeta.com",
    finchId: "51cbf167-3190-49ce-b8d6-312171a48af4",
  },
  {
    email: "zaintester82@gmail.com",
    finchId: "8b5291b7-0519-4a65-9b90-cdffe532b3b7",
  },
  {
    email: "zain@nettify.no",
    finchId: "ca211619-e6b7-490c-9b89-70093a142c13",
  },
  // {
  //   email: "johnyadav129@gmail.com",
  //   finchId: "53444ce4-f13a-43f7-9d84-b2711a217d88",
  // },
  //* Madan added these ids -------->
  {
    email: "tchung@marqeta.com",
    finchId: "57807a90-e40d-4e55-a5ef-8f991ada6b59",
  },
  {
    email: "jli@marqeta.com",
    finchId: "6cff2695-d33e-4516-b27e-1f9f4d2b0297",
  }
];

export const COMPANY_NAME = "Marqueta";
